//@config
export default {
  ticket: {
    base: "v1/ticket",
    ticket_detail: "v1/ticket/{0}/detail",
    all_ticket: "v1/all_ticket",
    ticket_answer: "v1/ticket/{0}/answer",
    all_ticket_unit: "v1/all_ticket/{0}/unit",
    all_ticket_sms: "v1/all_ticket/{0}/sms",
    all_ticket_users: "v1/all_ticket_users",
    ticket_done: "v1/ticket/{0}/done",
    search_active_users_enable: "v1/user-combo?search_txt={0}&is_enable=1",
    ticket_unit_id:'v1/ticket/unit/{0}',
    user_parvandeh_combo:"v1/parvandeh_combo",
    import_ticket:"v1/import_ticket",
    ticket_access:"v1/ticket_access",
    ticket_access_id:"v1/ticket_access/{0}",
  }
};
